const US_STATES = [
  { 'code': 'AL', 'name': 'Alabama' }, { 'code': 'AK', 'name': 'Alaska' },
  {
    'code': 'AZ',
    'name': 'Arizona'
  }, { 'code': 'AR', 'name': 'Arkansas' }, { 'code': 'CA', 'name': 'California' }, {
    'code': 'CO',
    'name': 'Colorado'
  }, { 'code': 'CT', 'name': 'Connecticut' }, { 'code': 'DE', 'name': 'Delaware' }, {
    'code': 'DC',
    'name': 'DistrictofColumbia'
  }, { 'code': 'FL', 'name': 'Florida' }, { 'code': 'GA', 'name': 'Georgia' }, {
    'code': 'HI',
    'name': 'Hawaii'
  }, { 'code': 'ID', 'name': 'Idaho' }, { 'code': 'IL', 'name': 'Illinois' }, {
    'code': 'IN',
    'name': 'Indiana'
  }, { 'code': 'IA', 'name': 'Iowa' }, { 'code': 'KS', 'name': 'Kansas' }, { 'code': 'KY', 'name': 'Kentucky' }, {
    'code': 'LA',
    'name': 'Louisiana'
  }, { 'code': 'ME', 'name': 'Maine' }, { 'code': 'MD', 'name': 'Maryland' }, {
    'code': 'MA',
    'name': 'Massachusetts'
  }, { 'code': 'MI', 'name': 'Michigan' }, { 'code': 'MN', 'name': 'Minnesota' }, {
    'code': 'MS',
    'name': 'Mississippi'
  }, { 'code': 'MO', 'name': 'Missouri' }, { 'code': 'MT', 'name': 'Montana' }, {
    'code': 'NE',
    'name': 'Nebraska'
  }, { 'code': 'NV', 'name': 'Nevada' }, { 'code': 'NH', 'name': 'NewHampshire' }, {
    'code': 'NJ',
    'name': 'NewJersey'
  }, { 'code': 'NM', 'name': 'NewMexico' }, { 'code': 'NY', 'name': 'NewYork' }, {
    'code': 'NC',
    'name': 'NorthCarolina'
  }, { 'code': 'ND', 'name': 'NorthDakota' }, { 'code': 'OH', 'name': 'Ohio' }, {
    'code': 'OK',
    'name': 'Oklahoma'
  }, { 'code': 'OR', 'name': 'Oregon' }, { 'code': 'PA', 'name': 'Pennsylvania' }, {
    'code': 'PR',
    'name': 'PuertoRico'
  }, { 'code': 'RI', 'name': 'RhodeIsland' }, { 'code': 'SC', 'name': 'SouthCarolina' }, {
    'code': 'SD',
    'name': 'SouthDakota'
  }, { 'code': 'TN', 'name': 'Tennessee' }, { 'code': 'TX', 'name': 'Texas' }, { 'code': 'UT', 'name': 'Utah' }, {
    'code': 'VT',
    'name': 'Vermont'
  }, { 'code': 'VA', 'name': 'Virginia' }, { 'code': 'WA', 'name': 'Washington' }, {
    'code': 'WV',
    'name': 'WestVirginia'
  }, { 'code': 'WI', 'name': 'Wisconsin' }, { 'code': 'WY', 'name': 'Wyoming' }]
export default {
  US_STATES
}
